// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".x-ButtonGroup {\n  display: flex;\n  justify-content: flex-end;\n}\n.x-ButtonGroup > *:not(:first-child) {\n  margin-left: 5px;\n}\n", "",{"version":3,"sources":["webpack://./modules/ui/components/controls/ButtonGroup.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;AACF;AAAE;EACE,gBAAA;AAEJ","sourcesContent":[".root {\n  display: flex;\n  justify-content: flex-end;\n  & > *:not(:first-child) {\n    margin-left: 5px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "x-ButtonGroup"
};
export default ___CSS_LOADER_EXPORT___;
